import {
    ChangeDetectionStrategy,
    Component,
    Injectable,
    Input,
} from '@angular/core';
import {
    IQueueItem,
    IQueueItemEvent,
    ODataResponse,
} from '@models';
import {
    GRID_SERVICE,
    IGridSource,
    ODataGridComponent,
} from '@pages/generics/grid';
import {
    ODataQueryOptions,
    QueueItemEventService,
} from '@services';

@Injectable()
export class TransactionEventSource implements IGridSource<ODataQueryOptions, ODataResponse<IQueueItem>> {
    public queueItemId!: number;

    public get mapper() {
        return this._queueItemEvent.mapper;
    }

    constructor(
        private _queueItemEvent: QueueItemEventService,
    ) { }

    public get(qo: ODataQueryOptions) {
        return this._queueItemEvent.getByItem(this.queueItemId, qo);
    }
}

@Component({
    selector: 'ui-transaction-events',
    templateUrl: './transaction-events.grid.html',
    providers: [
        {
            provide: GRID_SERVICE,
            useClass: TransactionEventSource,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionEventsGridComponent extends ODataGridComponent<IQueueItemEvent, number> {
    @Input()
    public set queueItem(value: IQueueItem) {
        const svc = (this._service as TransactionEventSource);
        if (!
            !svc &&
            !!value &&
            svc.queueItemId !== value.id
        ) {
            svc.queueItemId = value.id;
        }
    }
}
